export class OpenRoutes {
  public static readonly login: string = '/login';
  public static readonly register: string = '/register-tmp';
  public static readonly recover: string = '/recovery';
  public static readonly restore: string = '/restore';
}
